"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductMenuEditViewModel = instanceOfProductMenuEditViewModel;
exports.ProductMenuEditViewModelFromJSON = ProductMenuEditViewModelFromJSON;
exports.ProductMenuEditViewModelFromJSONTyped = ProductMenuEditViewModelFromJSONTyped;
exports.ProductMenuEditViewModelToJSON = ProductMenuEditViewModelToJSON;
exports.ProductMenuEditViewModelToJSONTyped = ProductMenuEditViewModelToJSONTyped;
/**
 * Check if a given object implements the ProductMenuEditViewModel interface.
 */
function instanceOfProductMenuEditViewModel(value) {
    return true;
}
function ProductMenuEditViewModelFromJSON(json) {
    return ProductMenuEditViewModelFromJSONTyped(json, false);
}
function ProductMenuEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wspmMenuNo': json['wspmMenuNo'] == null ? undefined : json['wspmMenuNo'],
        'wspmWebSiteNo': json['wspmWebSiteNo'] == null ? undefined : json['wspmWebSiteNo'],
        'wspmParent': json['wspmParent'] == null ? undefined : json['wspmParent'],
        'wspmName': json['wspmName'] == null ? undefined : json['wspmName'],
        'wspmOrder': json['wspmOrder'] == null ? undefined : json['wspmOrder'],
        'wspmUseStatus': json['wspmUseStatus'] == null ? undefined : json['wspmUseStatus'],
        'wspmMenuId': json['wspmMenuId'] == null ? undefined : json['wspmMenuId'],
    };
}
function ProductMenuEditViewModelToJSON(json) {
    return ProductMenuEditViewModelToJSONTyped(json, false);
}
function ProductMenuEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wspmMenuNo': value['wspmMenuNo'],
        'wspmWebSiteNo': value['wspmWebSiteNo'],
        'wspmParent': value['wspmParent'],
        'wspmName': value['wspmName'],
        'wspmOrder': value['wspmOrder'],
        'wspmUseStatus': value['wspmUseStatus'],
        'wspmMenuId': value['wspmMenuId'],
    };
}
